import {api} from "../api.slice";
import {INews} from "@/types/general";
import {apiEndpoints} from "@/utils/api-endpoints";


const newsApi = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getNews: builder.query<INews[], void>({
            query: () => apiEndpoints.News.GetAll.url,
            providesTags: (result, error, arg) => [{type: 'News', arg}],

        })
    })
})

export const {
    useGetNewsQuery
} = newsApi